import React from "react";
import { Row, Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { func, bool, number, oneOfType } from "prop-types";
import infoIcon from "resources/images/info.svg";
import { odaUrl } from "../../utils/env";

const AssessmentMode = ({ supervised, handleSupervisedOnChange }) => {
  const tooltip = (
    <Tooltip id="assessmentMode" className="assessmentModeTooltip">
      You can invite your candidates to either (1) complete assessments remotely
      at a location of their choice, or (2) complete assessments on-site under
      supervised conditions, usually in your office or an assessment center.
    </Tooltip>
  );

  return (
    <>
      <Row>
        <Col>
          <div className="font-weight-bold mb-3">
            Assessment Mode
            <OverlayTrigger placement="right" overlay={tooltip}>
              <span className="ml-1">
                <img
                  src={infoIcon}
                  width="16px"
                  height="16px"
                  alt="more information"
                  style={{ marginBottom: "2px" }}
                />
              </span>
            </OverlayTrigger>
          </div>
          <Form.Group>
            <Form.Check
              type="radio"
              name="remote"
              value={0}
              checked={!supervised}
              id="remoteRadioBtn"
              onChange={handleSupervisedOnChange}
              label="Remote"
              inline
            />
            <Form.Check
              type="radio"
              name="onSite"
              value={1}
              checked={supervised}
              id="onSiteRadioBtn"
              onChange={handleSupervisedOnChange}
              label="On-site"
              inline
            />
          </Form.Group>
        </Col>
      </Row>
      {supervised ? (
        <Row>
          <Col>
            <div className="notifications-info-box p-4 mb-2">
              <h4>On-Site Testing Instructions</h4>
              <p className="mb-2">
                To schedule candidates for On-Site Testing, click the “Invite”
                button below. Candidates will not receive an email invitation.
                You will be able to download a list of Event IDs after you
                schedule the candidates by clicking “Invite.” You can also
                download this list later in the bulk action dropdown.
              </p>
              <p>Before the candidate begins testing please ensure that:</p>
              <p className="pl-2 mb-1">
                - The candidate does not have access to any other materials
                (e.g. mobile phone, calculator)
              </p>
              <p className="pl-2 mb-1">
                - The candidate has access to a pen/pencil and paper if needed
              </p>
              <p className="pl-2 mb-1">
                - The candidate can complete the assessment undisturbed
              </p>
              <p className="mt-3 mb-1">
                {"To begin testing, instruct the candidate to go to"}{" "}
                <a
                  href={odaUrl}
                  target="_blank"
                  className="font-weight-bold"
                  style={{ textDecoration: "underline", color: "#425cc7" }}
                >
                  {odaUrl}
                </a>{" "}
                {`and enter their candidate's Event ID.`}
              </p>
            </div>
            <p style={{ color: "#86888b" }}>
              You will be able to download the list of Event IDs (CSV) after you
              finish this step.
            </p>
          </Col>
        </Row>
      ) : null}
    </>
  );
};

AssessmentMode.propTypes = {
  supervised: oneOfType([number, bool]),
  handleSupervisedOnChange: func,
};

export default AssessmentMode;
